import { useEffect, useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Flame } from "lucide-react";
import { Bunting, Marigold, Sparkle, SunDiya } from "@/components/art/Poster";
import { PosterTitle } from "@/components/invite/Reveal";

export default function Opening({ ev, onEnter }) {
  const reduce = useReducedMotion();
  const [phase, setPhase] = useState("idle");
  const timers = useRef([]);
  const btn = useRef(null);
  const title = ev?.title || "Diye, Dost Aur Drama";

  useEffect(() => {
    btn.current?.focus();
    const list = timers.current;
    return () => list.forEach(clearTimeout);
  }, []);

  const start = () => {
    if (phase !== "idle") return;
    setPhase("lit");
    timers.current.push(setTimeout(onEnter, reduce ? 400 : 1500));
  };
  const busy = phase !== "idle";

  return (
    <motion.div
      role="dialog"
      aria-modal="true"
      aria-labelledby="opening-title"
      className="bg-pink-print on-dark fixed inset-0 z-[100] overflow-y-auto"
      exit={{ opacity: 0, scale: 1.03 }}
      transition={{ duration: 0.4 }}
      data-testid="diya-opening-screen"
    >
      <div className="dots-cream pointer-events-none absolute inset-0" aria-hidden="true" />
      <Bunting className="relative h-[52px] w-full sm:h-[64px]" width={1440} flags={22} />
      <div className="relative mx-auto grid min-h-[calc(100%-64px)] max-w-6xl items-center gap-2 px-5 pb-10 pt-2 lg:grid-cols-2 lg:gap-12 lg:px-10">
        <div className="relative mx-auto w-[min(64vw,34svh,300px)] lg:order-2 lg:w-full lg:max-w-[480px]">
          <SunDiya lit={busy} burst={busy && !reduce ? "boom" : "settle"} />
          <Marigold className="absolute -left-2 top-2 w-10 lg:w-16" />
          <Marigold className="absolute -right-1 bottom-6 w-8 lg:w-12" />
          <Sparkle className="absolute right-2 top-0 w-7 lg:w-10" color="#FFF7E8" />
          <Sparkle className="absolute bottom-2 left-4 w-6 lg:w-9" />
        </div>
        <motion.div className="text-center lg:order-1 lg:text-left" animate={{ opacity: busy ? 0.0 : 1, y: busy ? -10 : 0 }} transition={{ duration: 0.35, delay: busy ? 0.7 : 0 }}>
          <span className="pill">{ev?.opening_eyebrow || "PRIVATE PARTY • INVITE ONLY"}</span>
          <PosterTitle id="opening-title" text={title} light as="h1" className="mt-4 text-[clamp(3.2rem,15vw,6.4rem)]" />
          <p className="font-serif-i mt-3 text-2xl text-[var(--cream)] sm:text-3xl">{ev?.opening_line || "Guest list exclusive hai. Drama unlimited."}</p>
          <div className="mt-6 flex flex-col items-stretch gap-3 sm:flex-row sm:justify-center lg:justify-start">
            <button ref={btn} type="button" onClick={start} disabled={busy} className="btn-primary text-base sm:text-lg" data-testid="enter-button">
              <Flame className="h-5 w-5" aria-hidden="true" /> Diya jalao aur andar aao
            </button>
          </div>
          <button type="button" onClick={onEnter} disabled={busy} className="mt-3 min-h-[44px] px-2 text-sm font-bold text-[var(--cream)] underline decoration-[var(--yellow)] decoration-2 underline-offset-4" data-testid="skip-opening-button">
            Skip intro
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
}
